// Centralized permissions list for user roles

const permissions = [
    { 
        id: 5, 
        name: 'User Management', 
        description: 'Allows the user to create and edit user accounts',
    },
    { 
        id: 6, 
        name: 'Inventory Management', 
        description: 'Allows the user to edit inventory items',
    },
    { 
        id: 7, 
        name: 'Card Management', 
        description: 'Allows the user to make and approve preference card edits',
    },
    {
        id: 9,
        name: 'Recommendation Reviewer',
        description: 'Allows the user access to the staff review portal for reviewing physician approved recommendations',
    },
    {
        id: 10,
        name: 'Campaign Monitor',
        description: 'Allows the user access to our campaign monitoring tools',
    },
    {
        id: 11,
        name: 'Change Implementer',
        description: 'Allows the user access to the implementer inbox suite of features',
    },
    {
        id: 12,
        name: 'Procedure Monitor',
        description: 'Allows the user access to our procedure analytics tools',
    },
];

export default permissions;
